/**
 * Picks a posting account, grouped by type. A native select: it works with a
 * keyboard, a screen reader and a phone without any extra code.
 */
import type { Account } from '../lib/queries';
import { ACCOUNT_TYPES, TYPE_LABEL } from '../lib/queries';
import { inputClass } from './ui';

export function AccountSelect({
  accounts,
  value,
  onChange,
  id,
  allowControl = false,
  placeholder = 'Choose an account',
  className,
}: {
  accounts: Account[];
  value: string;
  onChange: (id: string) => void;
  id?: string;
  /** Control accounts are for sub-ledgers; journals cannot use them. */
  allowControl?: boolean;
  placeholder?: string;
  className?: string;
}): JSX.Element {
  const usable = accounts.filter((a) => a.isPosting && (a.active || a.id === value) && (allowControl || !a.isControl));
  return (
    <select id={id} className={className ?? inputClass} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">{placeholder}</option>
      {ACCOUNT_TYPES.map((type) => {
        const group = usable.filter((a) => a.type === type);
        if (!group.length) return null;
        return (
          <optgroup key={type} label={TYPE_LABEL[type]}>
            {group.map((a) => (
              <option key={a.id} value={a.id}>
                {a.code} — {a.name}
              </option>
            ))}
          </optgroup>
        );
      })}
    </select>
  );
}
